module.exports = __webpack_public_path__ + "fonts/Montserrat-bold_358503d60a279006938864d6efa20e35.ttf";